import React, { FC } from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/layout'
import SEO from '../components/seo'
import PostCard from '../components/postCard'
import { AllMarkdownRemarkI, AllFileQueryI } from '../types/common'
import { SiteMetadataI, PostI } from '../types/data-models'

interface TagPageTemplateI {
  pageContext: {
    tag: string
  }
  data: {
    site: {
      siteMetadata: SiteMetadataI
    }
    posts: AllMarkdownRemarkI<PostI>
    location: Location
    thumbnails: AllFileQueryI
  }
}
const TagPageTemplate: FC<TagPageTemplateI> = ({
  pageContext: { tag },
  data: {
    posts,
    location,
    thumbnails,
    site: {
      siteMetadata: { title },
    },
  },
}) => (
  <Layout location={location} title={title}>
    <SEO
      // title={`#${tag}`}
      title={`#${tag.charAt(0).toUpperCase() + tag.slice(1)}`}
      keywords={[`${tag}`, `blog`, `gatsby`, `javascript`, `react`]}
    />
    <header className="tag-page-head">
      <h1 className="page-head-title">
        #{tag}({posts.totalCount})
      </h1>
    </header>
    <div className="post-feed">
      {posts.nodes.map((node) => {
        return <PostCard key={node.fields.slug} node={node} postClass={`post`} thumbnails={thumbnails} />
      })}
    </div>
  </Layout>
)

export const query = graphql`
  query PostByTag($tag: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    posts: allMarkdownRemark(
      filter: { frontmatter: { tags: { in: [$tag] } } }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      totalCount
      nodes {
        excerpt
        fields {
          slug
        }
        frontmatter {
          date(formatString: "MMMM DD, YYYY")
          title
          description
          tags
          thumbnail {
            url
            label
          }
        }
      }
    }
    thumbnails: allFile(filter: { sourceInstanceName: { eq: "images" } }) {
      edges {
        node {
          relativePath
          sourceInstanceName
          childImageSharp {
            gatsbyImageData(width: 1360, quality: 100, placeholder: BLURRED)
          }
          publicURL
        }
      }
    }
  }
`

export default TagPageTemplate
